module.exports = __webpack_public_path__ + "static/img/software13.a39d42c2.png";